import "./Hero02.css";

/**
 * @param {{ title: string; subtitle: string }} props
 */
function Hero02({ title, subtitle }) {
  return (
    <div className="Hero02 section" id="Hero02">
      <div className="container">
        <div className="Hero02-box">
          <h1>{title}</h1>

          <p>{subtitle}</p>
        </div>
      </div>
    </div>
  );
}

export default Hero02;
